import { IDT } from '@seen/core/models/care-teams/idt'
import { SDR } from '@seen/core/models/tasks/sdr/sdr'
import { SDRAction } from '@seen/core/models/tasks/sdr/sdr-action'
import type { JSX } from 'react'
import { useNavigate, useParams } from 'react-router'
import { FhirQueryLoader } from '#src/components/core/FhirQueryLoader.tsx'
import { SDRActionDisplay } from '#src/components/sdr/display/SDRActionDisplay.tsx'
import { SDRDisplay } from '#src/components/sdr/display/SDRDisplay.tsx'
import { useCurrentParticipant } from '#src/contexts/current-participant/useCurrentParticipant.ts'
import { useFhirRead } from '#src/hooks/useFhirRead.ts'
import { useSearchOne } from '#src/hooks/useSearchOne.ts'

export const SDRDisplayPage = (): JSX.Element => {
  const participant = useCurrentParticipant()
  const navigate = useNavigate()
  const { taskId } = useParams()
  const taskQuery = useFhirRead('Task', taskId)
  const careTeamQuery = useSearchOne(
    IDT,
    IDT.byParticipant(participant.reference)
  )

  return (
    <FhirQueryLoader query={[taskQuery, careTeamQuery]}>
      {([task, careTeam]) => {
        const handleNavigate = (taskId?: string): void => {
          void navigate(`/Patient/${participant.id}/sdr/${taskId ?? ''}`)
        }

        return (
          <>
            {SDR.isInstance(task) && (
              <SDRDisplay
                patient={participant.toFhirResource()}
                careTeam={careTeam}
                sdr={SDR.fromFhirResource(task)}
                onClickNavigate={handleNavigate}
              />
            )}
            {SDRAction.isInstance(task) && (
              <SDRActionDisplay
                sdr={SDRAction.fromFhirResource(task)}
                onClickNavigate={handleNavigate}
              />
            )}
          </>
        )
      }}
    </FhirQueryLoader>
  )
}
